<template>
    <!-- 项目 -->
    <div>
        <page-content :pageType = pageType></page-content>
    </div>
</template>

<script>

import pageContent from '../../../components/thingjs-x/page-content.vue'
export default {
    data() {
        return {
            pageType:{
                name: 'getProjects',
                pageType: ''
            }
        }
    },
    created () {

    },
    watch: {
        "$store.state.thingxProjectLink"(){
            if(this.$store.state.thingxProjectLink != 0){
                this.pageType.pageType = this.$store.state.thingxProjectLink;
                this.$router.push('/zeroCode/getProjects')
            }else{
                this.pageType.pageType = '';
            }
        },
    },
    components: {
      pageContent
    },
    methods: {

    }
}
</script>

<style lang = "less" scoped>

</style>



// WEBPACK FOOTER //
// src/views/thingjsX/getProject/getProject.vue